<template>
  <tr class="car-type-row">
    <td>
      <div class="text-center">
        <img style="max-height: 50px; max-width: 50px;" :src="carImage"/>
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ carType.variety }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ carType.make }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ carType.model }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ carType.year }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ carType.CarsCount }}
      </div>
    </td>
    <td>
      <span v-if="carType.CarClass" class="label" :class="randomLabel">
        {{ carType.CarClass.name }}
      </span>
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary" :to="{ path: `/fleet/vehicles/types/edit/${carType.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'CarTypeRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.carType.AmazonImage.objectKey
    },
    randomLabel () {
      if (this.carType.CarClass) {
        let num = this.carType.CarClass.name.charCodeAt(0)
        return {
          'label-success': num % 5 === 0,
          'label-primary': num % 5 === 1,
          'label-danger': num % 5 === 2,
          'label-info': num % 5 === 3,
          'label-warning': num % 5 === 4
        }
      } else {
        return {}
      }
    },
    carType () {
      return {
        AmazonImage: {},
        CarClass: {},
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/CarType.vue